/* system actions */
const SET_USER_CREDITS = 'plac/system/set_user_credit';
const SYSTEM_GENERATED_SCAN_ID = 'plac/system/generated_scan_id';

/* user actions */
const USER_UPLOADED_FILE = 'plac/user/uploaded_file';

export const placActionNames = { SET_USER_CREDITS, USER_UPLOADED_FILE, SYSTEM_GENERATED_SCAN_ID };
